import { useSelector } from 'react-redux';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Link, Typography } from '@mui/material';

import { AlertMessage } from '~/pages/CreateQR/sub-components/pdfTemplate/sub-components/AlertMessage';
import { getPdfReducer } from '~/store/reducers/previewScreens/pdf/selectors';
import { COLORS } from '~/styles/colors';
import { mainPreviewContainerStyles } from '~/styles/common';

type PDF_TEMPLATE_3Props = {
  isMyMicrosite?: boolean;
};
export function PDF_TEMPLATE_2({ isMyMicrosite }: PDF_TEMPLATE_3Props) {
  const pdfState = useSelector(getPdfReducer);

  const {
    bacgkroundColor,
    micrositeStyles,
    fonts: { head, text },
    basicInformation: { images },
    pdfInformation: { company, title, description, website },
  } = pdfState;

  return (
    <Box
      sx={{
        ...mainPreviewContainerStyles,
        alignItems: 'normal',
        background: `linear-gradient(180deg, ${bacgkroundColor[0]} 0%, ${bacgkroundColor[1]} 100%);`,
        ...micrositeStyles?.container,
        margin: isMyMicrosite ? undefined : '0 12px',
        width: isMyMicrosite ? '100%' : 'calc(100% - 24px)',
        height: 'calc(100% - 28px)',
        ...(isMyMicrosite ? { borderRadius: 0, minHeight: '100dvh' } : {}),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          minWidth: '100%',
          position: 'relative',
          height: '100%',
        }}
      >
        {!!images.length || company || title || description || website ? (
          <Box sx={{ padding: '0 1rem' }}>
            <Typography
              sx={{ fontFamily: text, fontSize: 12, mt: 3, mb: 3, wordBreak: 'break-word', color: COLORS.white }}
            >
              {company}
            </Typography>
            <Box
              sx={{
                backgroundColor: COLORS.white,
                mb: 2,
                borderRadius: '12px',
              }}
            >
              {(title || description) && (
                <Box sx={{ padding: 1 }}>
                  <Typography sx={{ fontFamily: head, fontSize: 18, mb: 2, mt: 2, wordBreak: 'break-word' }}>
                    {title}
                  </Typography>
                  <Typography sx={{ fontFamily: text, fontSize: 10, mb: 2, wordBreak: 'break-word' }}>
                    {description}
                  </Typography>
                </Box>
              )}
              {images.map((item, index) => {
                return (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      minHeight: 44,
                      padding: 1.5,
                      borderTop: `1px solid ${COLORS.black01}`,
                      cursor: 'pointer',
                    }}
                    onClick={() => window.open(item?.previewPdfLink, '_blank')}
                    key={index}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {item?.previewLink ? (
                        <img
                          src={item?.previewLink}
                          style={{ height: 28, width: 28, objectFit: 'cover', borderRadius: '8px' }}
                          alt="cover"
                        />
                      ) : null}
                      <Box sx={{ ml: 1, textAlign: 'left' }}>
                        <Typography sx={{ color: COLORS.black, fontSize: 11, wordBreak: 'break-word' }}>
                          {item?.name || item?.path}
                        </Typography>
                        <Typography sx={{ color: COLORS.disableGrayColor, fontSize: 11, wordBreak: 'break-word' }}>
                          {item?.description}
                        </Typography>
                      </Box>
                    </Box>
                    <ChevronRightIcon sx={{ color: COLORS.disableGrayColor, fontSize: '16px' }} />
                  </Box>
                );
              })}
            </Box>

            <Typography sx={{ fontFamily: text, fontSize: 13, mt: 2, mb: 2 }}>
              <Link
                href={website}
                target="_blank"
                sx={{ textDecoration: 'none', color: COLORS.white, wordBreak: 'break-word', pl: 1, pr: 1 }}
              >
                {website}
              </Link>
            </Typography>
          </Box>
        ) : (
          <AlertMessage />
        )}
      </Box>
    </Box>
  );
}
